import React from 'react'
import BallySportsNBA from 'src/components/page/bally-sports-nba'
import { videos } from 'src/constants/videos'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsNBA
    location={props.location}
    video={videos.bally_grizzlies.videoUrl}
    staticAnnotation={videos.bally_grizzlies.staticAnnotation}
    title="Watch Memphis basketball live"
    subtitle="Stream the Grizzlies on FanDuel Sports Network Southeast"
    teamId={teamIds['Memphis Grizzlies']}
  />
)
